import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
  Label,
  NavItem,
  Nav,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import { NavLink as DomNavLink } from "react-router-dom";
import { useState, React, useEffect, useRef, useContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import SelectComponent from "components/Utils/select.js";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import Switch from "react-bootstrap-switch";
import { useTranslation } from "react-i18next";
import { room_numbering_strategy_options } from "data/sites";
("../../../data/sites");
LoadingOverlay.propTypes = undefined;

const SiteEdit = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [selectAll, setSelectAll] = useState(false);

  const [horizontalTabs, setHorizontalTabs] = useState("devices");

  let formError = false;

  const [values, setValues] = useState({
    name: "",
    address: "",
    clientName: "",
    clientAddress: "",
    expectedRooms: 0,
    expectedGAMs: 0,
    allowManualRoomChange: false,
    trackCrew: false,
    template: "",
    roomNumberingStrategy: "SCANNING_PHASE",
    roomNumberingFormula: "",
  });

  const [states, setStates] = useState({
    name: "",
    address: "",
    clientName: "",
    clientAddress: "",
    expectedRooms: "",
    expectedGAMs: "",
    allowManualRoomChange: "",
    trackCrew: "",
    template: "",
    roomNumberingStrategy: "",
    roomNumberingFormula: "",
  });

  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [selectedRoomNumberingStrategy, setSelectedRoomNumberingStrategy] =
    useState(
      room_numbering_strategy_options.find(
        (o) => o.value === "SCANNING_PHASE",
      ) ?? room_numbering_strategy_options[0],
    );
  const [templates, setTemplates] = useState([]);

  const [params, setParams] = useState(location.state?.value ?? "");
  const [oldName, setOldName] = useState(location.state?.name ?? "");
  const [mode, setMode] = useState(location.state ? location.state.mode : "");
  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["installations.site.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  useEffect(() => {
    if (mode == "edit") {
      fetchEditData();
    } else if (mode == "create") {
      fetchCreateData();
    }
  }, [mode]);

  // Actions to do on submit
  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    if (mode == "create" || mode == "edit") {
      if (values.roomNumberingStrategy === "SEQUENTIAL") {
        if (!values.roomNumberingFormula.includes("{SEQ}")) {
          setStates((s) => ({
            ...s,
            roomNumberingFormula: !values.roomNumberingFormula
              ? "This field is required"
              : "Formula must contain {SEQ}",
          }));
          formError = true;
          return;
        }
      }
    }
    // Validate all the field before calling the API
    if (mode == "create") {
      setStates({
        ...states,
        ["name"]: validateField("name"),
        ["address"]: validateField("address"),
        ["template"]: validateField("template"),
      });
    } else if (mode == "edit") {
      setStates({
        ...states,
        ["name"]: validateField("name"),
        ["address"]: validateField("address"),
      });
    }

    if (!formError) {
      postData();
    }
  };

  const validateField = (field) => {
    let status = "";
    if (values[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const fetchCreateData = () => {
    fetch("/api/v1/site/create", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        // Manage Template list
        const newTemplateOption = { value: "-1", label: "New Template" };

        let templateOptions = actualData.data;

        if (templateOptions.length > 0) {
          setTemplates([newTemplateOption, ...templateOptions]);
        } else {
          setTemplates([newTemplateOption]);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const fetchEditData = () => {
    setShowLoading(true);

    fetch("/api/v1/site/edit", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        siteId: params,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == "200") {
          actualData.data.devices.map((device) => {
            setSelectedDevices((selectedDevices) => [
              ...selectedDevices,
              device,
            ]);
          });

          // Manage Template list
          let templateOptions = actualData.data.siteTemplates;
          if (templateOptions.length > 0) {
            setTemplates(templateOptions);
          }

          var templateId = null;
          templateOptions.map((template) => {
            if (template.value == actualData.data.template) {
              setSelectedTemplate(template);
              templateId = template.value;
            }
          });

          const strategy =
            actualData.data.roomNumberingStrategy ?? "SCANNING_PHASE";
          setSelectedRoomNumberingStrategy(
            room_numbering_strategy_options.find((o) => o.value === strategy) ??
              room_numbering_strategy_options[0],
          );

          setValues({
            ...values,
            address: actualData.data.address,
            id: actualData.data.id,
            name: actualData.data.name,
            clientName: actualData.data.clientName,
            clientAddress: actualData.data.clientAddress,
            expectedGAMs: actualData.data.expectedGAMs,
            expectedRooms: actualData.data.expectedRooms,
            allowManualRoomChange: actualData.data.allowManualRoomChange,
            trackCrew: actualData.data.trackCrew,
            template: templateId,
            roomNumberingStrategy: strategy,
            roomNumberingFormula: actualData.data.roomNumberingFormula ?? "",
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const postData = () => {
    setShowLoading(true);

    // Prepare Url and Api Method
    let apiUrl = "";
    let apiMethod = "";
    if (mode == "edit") {
      apiUrl = "/api/v1/site/edit";
      apiMethod = "PUT";
    } else if (mode == "create") {
      apiUrl = "/api/v1/site/create";
      apiMethod = "POST";
    }

    // Call the API
    fetch(apiUrl, {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        oldname: oldName,
        name: values.name,
        address: values.address,
        clientName: values.clientName,
        clientAddress: values.clientAddress,
        expectedGAMs: values.expectedGAMs,
        expectedRooms: values.expectedRooms,
        allowManualRoomChange: values.allowManualRoomChange,
        devices: selectedDevices,
        trackCrew: values.trackCrew,
        template: values.template,
        roomNumberingStrategy: values.roomNumberingStrategy,
        roomNumberingFormula: values.roomNumberingFormula,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error(
            t(
              "sites.edit.save.error.t." + sessionStorage.getItem("bundleType"),
              "Sites",
            ),
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          setErrorMsg([]);
          toast.success(
            t(
              "sites.edit.save.successfull.t." +
                sessionStorage.getItem("bundleType"),
              "Sites",
            ),
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );

          redirectToSiteListPage();
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSwitchChange = (e) => {
    const { props, state } = e;

    setValues({
      ...values,
      [props.name]: state.value,
    });
  };

  const handleDeviceCheckbox = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedDevices((selectedDevices) => [...selectedDevices, value]);
    } else {
      setSelectedDevices((device) => device.filter((v) => v !== value));
    }
  };

  const handleSelectAll = (e, data) => {
    const { checked } = e.target;
    if (checked) {
      setSelectAll(true);
      setSelectedDevices([]);
      setSelectedDevices(data.map((device) => device.serialNumber));
    } else {
      setSelectAll(false);
      setSelectedDevices([]);
    }
  };

  const handleTemplateChange = (option) => {
    setValues({
      ...values,
      ["template"]: option.value.value,
    });
    setSelectedTemplate(option);
  };

  const handleRoomNumberingStrategyChange = (option) => {
    setValues({ ...values, roomNumberingStrategy: option.value.value });
    setSelectedRoomNumberingStrategy(option);
  };

  const deviceColumns = [
    {
      Header: (props) => {
        return (
          <div style={{ paddingLeft: "0px", paddingBottom: "8px" }}>
            <FormGroup check>
              <Label check>
                <>
                  <Input
                    type="checkbox"
                    name="endpointAll"
                    onChange={(event) => handleSelectAll(event, props.data)}
                    checked={selectAll}
                  />
                  <span className="form-check-sign" />
                </>
              </Label>
            </FormGroup>
          </div>
        );
      },
      accessor: "actions",
      sortable: false,
      filterable: false,
      flex: "1 1 0",
      Cell: (props) => {
        return (
          <div style={{ paddingLeft: "7px", paddingBottom: "7px" }}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  value={props.row.original.serialNumber}
                  checked={selectedDevices.includes(
                    props.row.original.serialNumber,
                  )}
                  onChange={handleDeviceCheckbox}
                />
                <span className="form-check-sign" />
              </Label>
            </FormGroup>
          </div>
        );
      },
    },
    {
      Header: "System Name",
      accessor: "name",
      sortBy: "name",
      flex: "1 1 0",
    },
    {
      Header: "Serial Number",
      accessor: "serialNumber",
      sortBy: "serialNumber",
      flex: "1 1 0",
    },
    {
      Header: "IP Address",
      accessor: "ipAddress",
      sortBy: "ipAddress",
      flex: "1 1 0",
    },
  ];

  const redirectToSiteListPage = () => {
    const location = {
      pathname: "/admin/installations/site/list",
    };
    history.push(location);
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </DomNavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/installations/site/list",
                      }}
                    >
                      {t(
                        "sites.breadcrumb.sites.t." +
                          sessionStorage.getItem("bundleType"),
                        "Sites",
                      )}
                    </DomNavLink>
                    {oldName ? <i>&lt;{oldName}&gt;</i> : ""}
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    {mode == "create" ? "Create" : ""}
                    {mode == "edit" ? "Edit" : ""}
                  </BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  {t(
                    "sites.edit.title.information.t." +
                      sessionStorage.getItem("bundleType"),
                    "Site Information",
                  )}
                </CardTitle>
              </CardHeader>
              <CardBody>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <label>Name</label>
                      <FormGroup
                        className={
                          states["name"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          placeholder="Enter Hotel Name"
                          type="text"
                          name="name"
                          onChange={handleInputChange}
                          value={values ? values.name : ""}
                        />
                        <label className="error">{states["name"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>Address</label>
                      <FormGroup
                        className={
                          states["address"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          placeholder="Enter Hotel Address"
                          type="text"
                          name="address"
                          onChange={handleInputChange}
                          value={values ? values.address : ""}
                        />
                        <label className="error">{states["address"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <SelectComponent
                        label="Template"
                        fieldName={"template"}
                        array={templates}
                        stateValue={states["template"]}
                        onChange={(option) => {
                          handleTemplateChange(option);
                        }}
                        selectedOption={selectedTemplate}
                      />
                    </Col>
                    <Col>
                      <SelectComponent
                        label="Room Numbering Strategy"
                        fieldName="roomNumberingStrategy"
                        array={room_numbering_strategy_options}
                        stateValue={states["roomNumberingStrategy"]}
                        onChange={(option) =>
                          handleRoomNumberingStrategyChange(option)
                        }
                        selectedOption={selectedRoomNumberingStrategy}
                      />
                    </Col>
                    {values.roomNumberingStrategy === "SEQUENTIAL" && (
                      <Col>
                        <label>Room Numbering Formula</label>
                        <FormGroup
                          className={
                            states["roomNumberingFormula"].length !== 0
                              ? "has-danger"
                              : ""
                          }
                        >
                          <Input
                            placeholder="e.g. SITE-{SEQ}"
                            type="text"
                            name="roomNumberingFormula"
                            onChange={handleInputChange}
                            value={values.roomNumberingFormula}
                          />
                          <label className="error">
                            {states["roomNumberingFormula"]}
                          </label>
                        </FormGroup>
                      </Col>
                    )}
                    {values.roomNumberingStrategy !== "SEQUENTIAL" && <Col />}
                  </Row>
                  <Row>
                    <Col>
                      <label>Client Name</label>
                      <FormGroup
                        className={
                          states["clientName"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          placeholder="Enter Client Name"
                          type="text"
                          name="clientName"
                          onChange={handleInputChange}
                          value={values ? values.clientName : ""}
                        />
                        <label className="error">{states["clientName"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>Client Address</label>
                      <FormGroup
                        className={
                          states["clientAddress"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          placeholder="Enter Client Address"
                          type="text"
                          name="clientAddress"
                          onChange={handleInputChange}
                          value={values ? values.clientAddress : ""}
                        />
                        <label className="error">
                          {states["clientAddress"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>Allow Manual Endpoint Change</label>
                      <FormGroup>
                        <Switch
                          name="allowManualRoomChange"
                          offColor="success"
                          offText={<i className="nc-icon nc-simple-remove" />}
                          onColor="success"
                          onText={<i className="nc-icon nc-check-2" />}
                          onChange={handleSwitchChange}
                          value={values["allowManualRoomChange"] ? true : false}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>Track Crew Members</label>
                      <FormGroup>
                        <Switch
                          name="trackCrew"
                          offColor="success"
                          offText={<i className="nc-icon nc-simple-remove" />}
                          onColor="success"
                          onText={<i className="nc-icon nc-check-2" />}
                          onChange={handleSwitchChange}
                          value={values["trackCrew"] ? true : false}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>Expected Endpoints</label>
                      <FormGroup
                        className={
                          states["expectedRooms"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          type="number"
                          name="expectedRooms"
                          min="0"
                          onChange={handleInputChange}
                          value={values ? values.expectedRooms : 0}
                        />
                        <label className="error">
                          {states["expectedRooms"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>Expected GAMs</label>
                      <FormGroup
                        className={
                          states["expectedGAMs"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          type="number"
                          name="expectedGAMs"
                          min="0"
                          onChange={handleInputChange}
                          value={values ? values.expectedGAMs : 0}
                        />
                        <label className="error">
                          {states["expectedGAMs"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col></Col>
                    <Col></Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="nav-tabs-navigation">
                        <div className="nav-tabs-wrapper">
                          <Nav id="tabs" role="tablist" tabs>
                            <NavItem>
                              <NavLink
                                aria-expanded={horizontalTabs === "devices"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  horizontalTabs === "devices" ? "active" : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setHorizontalTabs("devices")}
                              >
                                Devices
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TabContent
                        id="my-tab-content"
                        activeTab={horizontalTabs}
                        style={{ paddingLeft: "20px" }}
                      >
                        <TabPane tabId="devices" role="tabpanel">
                          <ReactTable
                            query="/api/v1/site/device/edit"
                            columns={deviceColumns}
                            title="Devices"
                            className="-striped -highlight primary-pagination"
                            param={oldName}
                            showPagination={true}
                            showTitle={false}
                            showActionsButton={false}
                            showColumnsButton={false}
                          />
                        </TabPane>
                      </TabContent>
                    </Col>
                  </Row>
                  <Button className="btn-round" color="info" type="submit">
                    Submit
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SiteEdit;
